import React, { useState, useEffect, useRef } from 'react';
import SidebarTimeline from './SidebarTimeline';
import './RightSidebar.css';

function pad(n) {
  return String(n).padStart(2, '0');
}
function fmtTime(d) {
  return `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
}

const RightSidebar = ({
  rightSidebarOpen,
  onToggle,
  alertas = [],
  voos = [],
  loading = false,
  title = 'Painel Lateral',
  children,
  selectedTime = null,
  idioma = 'pt',
  onIdiomaChange,
}) => {
  const [now, setNow] = useState(new Date());
  const referenceTimeRef = useRef(null);
  const startedAtRef = useRef(Date.now());

  useEffect(() => {
    referenceTimeRef.current = selectedTime;
    if (selectedTime) {
      startedAtRef.current = Date.now();
      setNow(new Date(selectedTime));
    } else {
      setNow(new Date());
    }
  }, [selectedTime]);

  useEffect(() => {
    const id = setInterval(() => {
      if (referenceTimeRef.current) {
        const refDate = new Date(referenceTimeRef.current);
        const elapsed = Date.now() - startedAtRef.current;
        setNow(new Date(refDate.getTime() + elapsed));
      } else {
        setNow(new Date());
      }
    }, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <>
      <aside className={`right-sidebar ${rightSidebarOpen ? 'open' : 'closed'}`}>
        {/* Header */}
        {rightSidebarOpen && (
          <div className="right-sidebar-header">
            <span className="right-sidebar-clock">
              {fmtTime(now)}
              <span className="right-sidebar-clock-sec">:{pad(now.getUTCSeconds())}</span>
            </span>
            {/* Idioma e botão ✕ agrupados no canto direito do header */}
            <div className="right-sidebar-header-actions">
              <div className="right-sidebar-lang" role="group" aria-label={idioma === 'en' ? 'Language' : 'Idioma'}>
                <button
                  type="button"
                  className={`right-sidebar-lang-btn${idioma === 'pt' ? ' active' : ''}`}
                  onClick={() => onIdiomaChange && onIdiomaChange('pt')}
                >
                  Pt
                </button>
                <button
                  type="button"
                  className={`right-sidebar-lang-btn${idioma === 'en' ? ' active' : ''}`}
                  onClick={() => onIdiomaChange && onIdiomaChange('en')}
                >
                  En
                </button>
              </div>
              <button
                className="right-sidebar-toggle-button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (onToggle) {
                    onToggle(!rightSidebarOpen);
                  }
                }}
                aria-label={idioma === 'en' ? 'Close panel' : 'Fechar painel'}
                type="button"
              >
                ✕
              </button>
            </div>
          </div>
        )}

        {/* Conteúdo: timeline (linha do tempo) ou children */}
        {rightSidebarOpen && (
          <div className="right-sidebar-content">
            {loading ? (
              <div className="right-sidebar-content-inner">
                <div className="right-sidebar-loading">{idioma === 'en' ? 'Loading...' : 'Carregando...'}</div>
              </div>
            ) : children ? (
              <div className="right-sidebar-content-inner">{children}</div>
            ) : (
              <SidebarTimeline referenceTime={selectedTime} alertas={alertas} voos={voos} idioma={idioma} />
            )}
          </div>
        )}
      </aside>

      {/* Botão expandir quando fechado */}
      {!rightSidebarOpen && (
        <div className="right-sidebar-closed-actions">
          <button
            className="right-sidebar-expand-button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (onToggle) {
                onToggle(!rightSidebarOpen);
              }
            }}
            aria-label={idioma === 'en' ? 'Expand panel' : 'Expandir painel'}
            type="button"
          >
            ◀
          </button>
        </div>
      )}
    </>
  );
};

export default RightSidebar;

